import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getPracticeExamQuestions(examId) {
  return axios
    .post(`${BASE_URL}/getPracticeExamQuestions`, {
      examId,
    })
    .then(({ data }) => data);
}

export function getWeeklyPracticeExams() {
  return axios
    .post(`${BASE_URL}/getWeeklyPracticeExams`)
    .then(({ data }) => data);
}

export function startWeeklyPracticeExam(practiceExamId, userPracticeExamId) {
  return axios
    .post(`${BASE_URL}/startWeeklyPracticeExam`, {
      practiceExamId,
      userPracticeExamId,
    })
    .then(({ data }) => data);
}

export function updatePracticeExam(practiceExamId, dataResultsDetailed) {
  return axios
    .post(`${BASE_URL}/updatePracticeExam`, {
      practiceExamId,
      dataResultsDetailed,
    })
    .then(({ data }) => data);
}

export function submitPracticeExam(practiceExamId, dataResultsDetailed) {
  return axios
    .post(`${BASE_URL}/submitPracticeExam`, {
      practiceExamId,
      dataResultsDetailed,
    })
    .then(({ data }) => data);
}

export function resultPracticeExam(practiceExamId, retake) {
  return axios
    .get(`${BASE_URL}/resultPracticeExam/${practiceExamId}`, {
      params: {
        retake,
      },
    })
    .then(({ data }) => data);
}

export function getPracticeExamQuestionsService() {
  return 'test';
  //   return axios
  //     .post(`${BASE_URL}/disableQuestion/${questionId}`, payload)
  //     .then(({ data }) => data);
}

export function getPracticeExamAnswersService(questionId, payload) {
  return 'test';
  // return axios
  // .post(`${BASE_URL}/question/${questionId}/report`, payload)
  // .then(({ data }) => data);
}

export function getPracticeExamResultsService(questionId, payload) {
  return 'test';
  // return axios
  // .post(`${BASE_URL}/question/${questionId}/report`, payload)
  // .then(({ data }) => data);
}

export function sendPracticeExamAnswerService(questionId, payload) {
  return 'test';
  // return axios
  // .post(`${BASE_URL}/question/${questionId}/report`, payload)
  // .then(({ data }) => data);
}

export function sendPracticeExamFinalAnswersService(questionId, payload) {
  return 'test';
  // return axios
  // .post(`${BASE_URL}/question/${questionId}/report`, payload)
  // .then(({ data }) => data);
}

// CUSTOM PRACTICE EXAM

export function generateCustomPracticeExam(chapterIds, isRegeneration) {
  return axios
    .post(`${BASE_URL}/generateCustomPracticeExam`, {
      chapterIds,
      isRegeneration,
    })
    .then(({ data }) => data);
}

export function getCustomPracticeExamReferences(rateId) {
  return axios
    .get(`${BASE_URL}/referenceDataForCustomExam`, {
      params: { rateId },
    })
    .then(({ data }) => data);
}

export function getCustomPracticeExamQuestions(examId) {
  return axios
    .post(`${BASE_URL}/getCustomPracticeExamQuestions`, {
      examId,
    })
    .then(({ data }) => data);
}

export function checkCustomPracticeExamStatus() {
  return axios
    .post(`${BASE_URL}/checkCustomPracticeExamStatus`)
    .then(({ data }) => data);
}

export function resultCustomPracticeExam(practiceExamId) {
  return axios
    .get(`${BASE_URL}/resultCustomPracticeExam/${practiceExamId}`)
    .then(({ data }) => data);
}

export function submitCustomPracticeExam(practiceExam, dataResultsDetailed) {
  return axios
    .post(`${BASE_URL}/submitCustomPracticeExam`, {
      practiceExam,
      dataResultsDetailed,
    })
    .then(({ data }) => data);
}

export function updateCustomPracticeExam(practiceExamId, dataResultsDetailed) {
  return axios
    .post(`${BASE_URL}/updateCustomPracticeExam`, {
      practiceExamId,
      dataResultsDetailed,
    })
    .then(({ data }) => data);
}

export function startCustomPracticeExam(startedAt) {
  return axios
    .post(`${BASE_URL}/startCustomPracticeExam`, {
      startedAt,
    })
    .then(({ data }) => data);
}

export function getCustomPracticeExamSettings() {
  return axios
    .get(`${BASE_URL}/getCustomPracticeExamSettings`)
    .then(({ data }) => data);
}
